import { render, staticRenderFns } from "./sDataInsuredView.vue?vue&type=template&id=a6aa0d0a"
import script from "./sDataInsuredView.vue?vue&type=script&lang=js"
export * from "./sDataInsuredView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports